<template>
	<div class="container">
		<el-card>
			<div slot="header">能耗报表</div>
			<div style="height: 100%">
				<el-tabs v-model="activeName" type="border-card">
					<el-tab-pane label="电表能耗报表" name="electric">
						<div style="display: flex">
							<div class="leftTree">
								<MerchantTree ref="merchantTree" :showCheckBox="false"
									v-on:treeMenuClick="treeMenuClick"></MerchantTree>
							</div>
							<div class="rightTable">
								<div class="echartStyle">
									<el-form ref="form" label-width="80px" size="small" style="margin-top: 15px">
										<div class="title">
											<el-form-item label="曲线范围">
												<el-radio v-model="meterRadio" label="1" @change="meterRadioChange">全部商户
												</el-radio>
												<el-radio v-model="meterRadio" label="0" @change="meterRadioChange">单一商户
												</el-radio>
											</el-form-item>
											<div class="btns" style="margin-left: 2%">
												<el-button type="primary" size="small"
													@click="dailyPowerConsumptionCurve">当日能耗曲线</el-button>
												<el-button type="primary" size="small"
													@click="yesterdayPowerConsumptionCurve">昨日能耗曲线</el-button>
												<el-button type="primary" size="small"
													@click="monthPowerConsumptionCurve">近30天能耗曲线</el-button>
											</div>
										</div>
									</el-form>
									<div class="container">
										<div class="leftEchart">
											<div class="pieChart" id="electricEnergyConsumptionChart"></div>
										</div>
									</div>
								</div>
							</div>
						</div>
					</el-tab-pane>
					<el-tab-pane label="水表能耗报表" name="water">
						<div style="display: flex">
							<div class="leftTree">
								<MerchantTree ref="merchantTree1" :showCheckBox="false"
									v-on:treeMenuClick="treeMenuClickWater"></MerchantTree>
							</div>
							<div class="rightTable">
								<div class="echartStyle">
									<el-form ref="form" label-width="80px" size="small" style="margin-top: 15px">
										<div class="title">
											<el-form-item label="曲线范围">
												<el-radio v-model="waterMeterRadio" label="1"
													@change="waterRadioChange">全部商户</el-radio>
												<el-radio v-model="waterMeterRadio" label="0"
													@change="waterRadioChange">单一商户</el-radio>
											</el-form-item>
											<div class="btns" style="margin-left: 2%">
												<el-button type="primary" size="small">近30天能耗曲线</el-button>
											</div>
										</div>
									</el-form>
									<div class="container">
										<div class="leftEchart">
											<div class="pieChart" id="waterEnergyConsumptionChart"></div>
										</div>
									</div>
								</div>

							</div>
						</div>
					</el-tab-pane>
				</el-tabs>
			</div>
		</el-card>
	</div>
</template>

<script>
	import MerchantTree from '../property/MerchantTree.vue';
	import {
		selectMeterUsageDataTotal,
		selectMeterUsageData,
		selectWaterUsageDataTotal,
		selectWaterUsageData,
	} from '../../api/report/energyConsumptionReport.js';
	import * as echarts from 'echarts';
	export default {
		components: {
			MerchantTree,
		},
		data() {
			return {
				activeName: 'electric',
				loading: false,
				// 曲线范围下拉框数据
				curveRangeOptions: [],
				// 电表格数据
				electricTableData: [],
				// 电表格列
				electricTableColumns: [],
				// 水表格数据
				waterTableData: [],
				// 水表格列
				waterTableColumns: [],
				// 电树id
				electricLesseeId: null,
				// 水树id
				waterLesseeId: null,
				// 电能耗曲线
				electricEnergyConsumptionLineChart: '',
				// 水能耗曲线
				waterEnergyConsumptionLineChart: '',
				meterRadio: '1',
				waterMeterRadio: '1',
				// 电曲线数据
				electricLineChartData: '',
				// 水曲线数据
				waterLineChartData: '',
				electricType: '当日',
				waterType: '近三十天',
			};
		},
		created() {},
		mounted() {
			this.init();
			// 重置图表
			window.addEventListener('resize', this.resizeChart);
		},
		watch: {
			$route(to) {
				if (to.path == '/mainWindow/energyConsumptionReport') {
					this.resizeChart();
				}
			},
			activeName(newVal) {
				if (newVal === 'electric') {
					this.$nextTick(() => {
						this.createElectricEnergyConsumptionChart();
					});
				} else if (newVal === 'water') {
					this.$nextTick(() => {
						this.createWaterEnergyConsumptionChart();
					});
				}
			},
		},
		methods: {
			async init() {
				await this.selectMeterUsageDataTotal();
				await this.selectWaterUsageDataTotal();
			},
			async meterRadioChange(radio) {
				if (radio == '1') {
					await this.selectMeterUsageDataTotal();
				} else {
					if (this.electricLesseeId == null) {
						this.$message.error('请先点击某个商户名称!');
					} else {
						await this.selectMeterUsageData();
					}
				}
			},
			async treeMenuClick() {
				this.electricLesseeId = this.$refs.merchantTree.nodeId;
				if (this.meterRadio == '0') {
					await this.selectMeterUsageData();
				}
			},
			async treeMenuClickWater() {
				this.waterLesseeId = this.$refs.merchantTree1.nodeId;
				if (this.waterMeterRadio == '0') {
					await this.selectWaterUsageData();
				}
			},
			// 全部商户电能耗查询
			async selectMeterUsageDataTotal() {
				let data = {
					type: this.electricType,
				};
				let res = await selectMeterUsageDataTotal(data).then();
				this.electricTableData = res.data.tableData;
				this.electricTableColumns = res.data.tableColumns;
				this.electricLineChartData = res.data.lineChartData;
				this.createElectricEnergyConsumptionChart();
			},
			// 获取电表单个商户能耗曲线数据
			async selectMeterUsageData() {
				let data = {
					type: this.electricType,
					lesseeId: this.electricLesseeId,
				};
				let res = await selectMeterUsageData(data).then();
				this.electricTableData = res.data.tableData;
				this.electricTableColumns = res.data.tableColumns;
				this.electricLineChartData = res.data.lineChartData;
				this.createElectricEnergyConsumptionChart();
			},
			// 当日电能耗查询
			async dailyPowerConsumptionCurve() {
				if (this.meterRadio == '1') {
					this.electricType = '当日';
					await this.selectMeterUsageDataTotal();
				} else {
					if (this.electricLesseeId == null) {
						this.$message.error('请先点击某个商户名称!');
					} else {
						this.electricType = '当日';
						await this.selectMeterUsageData();
					}
				}
			},
			// 昨天电能耗查询
			async yesterdayPowerConsumptionCurve() {
				if (this.meterRadio == '1') {
					this.electricType = '昨日';
					await this.selectMeterUsageDataTotal();
				} else {
					if (this.electricLesseeId == null) {
						this.$message.error('请先点击某个商户名称!');
					} else {
						this.electricType = '昨日';
						await this.selectMeterUsageData();
					}
				}
			},
			// 30天电能耗查询
			async monthPowerConsumptionCurve() {
				if (this.meterRadio == '1') {
					this.electricType = '近三十天';
					await this.selectMeterUsageDataTotal();
				} else {
					if (this.electricLesseeId == null) {
						this.$message.error('请先点击某个商户名称!');
					} else {
						this.electricType = '近三十天';
						await this.selectMeterUsageData();
					}
				}
			},
			// 全部商户水能耗查询
			async selectWaterUsageDataTotal() {
				let data = {
					type: this.waterType,
				};
				let res = await selectWaterUsageDataTotal(data).then();
				this.waterTableData = res.data.tableData;
				this.waterTableColumns = res.data.tableColumns;
				this.waterLineChartData = res.data.lineChartData;
				this.createWaterEnergyConsumptionChart();
			},
			// 获取水表单个商户能耗曲线数据
			async selectWaterUsageData() {
				let data = {
					type: this.waterType,
					lesseeId: this.waterLesseeId,
				};
				let res = await selectWaterUsageData(data).then();
				this.waterTableData = res.data.tableData;
				this.waterTableColumns = res.data.tableColumns;
				this.waterLineChartData = res.data.lineChartData;
				this.createWaterEnergyConsumptionChart();
			},
			async waterRadioChange(radio) {
				if (radio == '1') {
					await this.selectWaterUsageDataTotal();
				} else {
					if (this.waterLesseeId == null) {
						this.$message.error('请先点击某个商户名称!');
					} else {
						await this.selectWaterUsageData();
					}
				}
			},
			resizeChart() {
				this.electricEnergyConsumptionLineChart ?
					this.electricEnergyConsumptionLineChart.resize() :
					'';
				this.waterEnergyConsumptionLineChart ?
					this.waterEnergyConsumptionLineChart.resize() :
					'';
			},
			createElectricEnergyConsumptionChart() {
				var chartDom = document.getElementById('electricEnergyConsumptionChart');
				this.electricEnergyConsumptionLineChart = echarts.init(chartDom);
				var option = {
					tooltip: {
						trigger: 'axis',
						transitionDuration: 0,
						axisPointer: {
							type: 'cross',
							crossStyle: {
								color: '#999',
							},
						},
					},
					grid: {
						left: 50,
						right: 20,
					},
					title: {
						text: this.electricType,
						left: '48%',
					},
					xAxis: {
						type: 'category',
						data: this.electricLineChartData.xData,
					},
					yAxis: {
						type: 'value',
						name: 'kW·h',
					},
					series: [{
						data: this.electricLineChartData.yData,
						type: 'line',
						smooth: true,
					}, ],
				};

				option && this.electricEnergyConsumptionLineChart.setOption(option);
				this.electricEnergyConsumptionLineChart.resize();
			},
			createWaterEnergyConsumptionChart() {
				var chartDom = document.getElementById('waterEnergyConsumptionChart');
				this.waterEnergyConsumptionLineChart = echarts.init(chartDom);
				var option = {
					tooltip: {
						trigger: 'axis',
						transitionDuration: 0,
						axisPointer: {
							type: 'cross',
							crossStyle: {
								color: '#999',
							},
						},
					},
					grid: {
						left: 50,
						right: 20,
					},
					title: {
						text: this.waterType,
						left: '48%',
					},
					xAxis: {
						type: 'category',
						data: this.waterLineChartData.xData,
					},
					yAxis: {
						type: 'value',
						name: 'm³',
					},
					series: [{
						data: this.waterLineChartData.yData,
						type: 'line',
						smooth: true,
					}, ],
				};

				option && this.waterEnergyConsumptionLineChart.setOption(option);
				this.waterEnergyConsumptionLineChart.resize();
			},
		},
	};
</script>

<style lang="scss" scoped>
	.container {
		padding: 0 10px;
		height: 100%;
	}

	/deep/ .el-card__header {
		background-color: var(--secondColor) !important;
		color: var(--whiteColor);
	}

	/deep/ .el-form-item {
		display: inline-block;
	}

	.searchTag {
		width: 200px;
	}

	/deep/ .el-tabs {
		height: 100% !important;

		.el-tabs__content {
			height: calc(100% - 39px) !important;
		}
	}

	/deep/ .el-tabs__content {
		height: 100% !important;
	}

	.el-dialog {
		.el-form-item {
			width: 100%;

			.el-input {
				width: 100%;
			}
		}
	}

	/deep/ .el-input-group__append {
		cursor: pointer;
	}

	.leftTree {
		width: 400px;
		height: 100%;
		min-width: 180px;
		margin-right: 20px;
	}

	.rightTable {
		width: calc(100% - 400px);

		.echartStyle {
			height: 100%;

			.pieChart {
				width: 100%;
				height: 100%;
			}

			.title {
				display: flex;
				line-height: 32px;
				padding-right: 30px;
			}

			.container {
				height: calc(100% - 48px);
				display: flex;

				.leftEchart {
					margin-right: 10px;
					width: 100%;
				}
			}
		}

		.tableStyle {
			height: calc(100vh - 350px);
			width: 100%;
			height: 40%;
			overflow: hidden;
		}
	}

	.el-tab-pane {
		height: 100% !important;
	}

	// /deep/ .el-table--scrollable-x .el-table__body-wrapper {
	//   overflow: auto !important;
	// }
</style>
